import * as React from "react";
import { BaseComponent } from "../../../../../react-core/Html/BaseComponent";
import { Pager } from "../../../../../react-core/Html/Pager";
import { PartLoading } from "../../../../../react-core/Html/PartLoading";
import { ContentTable, ProcessTypeOptions, StatusOptions } from "../Resource/Content";
import { FirmInstructionHistoryCollectionModel } from "../../../../../Wrap/Models/Models/Company/FirmInstructionHistoryCollectionModel";
import { FirmInstructionHistoryAdapterModel } from "../../../../../Wrap/Models/Models/Company/FirmInstructionHistoryAdapterModel";
import { Dictionary, CommonHelper } from "../../../../../react-core/Helpers/CommonHelper";
import { JsonDateParser } from "../../../../../react-core/Utils/JsonDateParser";
import { Navigator } from "../../../../Shared/Wizards/Entities/Navigator";
import { Urls } from "../../../../Dashboard/Urls";
import { UserClient } from "../../../../../Wrap/Api/User/User";
import { UserStore } from "../../../../Dashboard/Stroes/Variable";
import { IndividualUserFunctionClient } from "../../../../../Wrap/Api/User/IndividualUserFunction";
interface ICompanyWizardTableProps {
    tableData?: FirmInstructionHistoryCollectionModel;
    currentPage: number;
    pageSize: number;
    isLoading: boolean;
    handlePageChange: any;
    handleSubmit?: any;
    inprogress: boolean;
}

interface ICompanyWizardTableState {
    itemsToDelete: Array<number>;
    hasCompanyPermission: boolean;
}

export class CompanyWizardTable extends BaseComponent<ICompanyWizardTableProps, ICompanyWizardTableState> {
    constructor(props: ICompanyWizardTableProps) {
        super(props);
        this.state = {
            itemsToDelete: [],
            hasCompanyPermission: false,
        };
    }

    componentDidMount() {
        const clientId = UserStore.getUserInfo().ClientId;

        if (clientId == null || clientId == 0) {
            const client = new UserClient();
            const promise = client.get();

            promise.onSuccess((result) => {
                this.checkCompanyPermission(result.ClientId);
            });
            promise.onError((err) => {});
        } else {
            this.checkCompanyPermission(clientId);
        }
    }

    public checkCompanyPermission(clientId: number) {
        const FunctionName = "CanModifyCompanies";
        const client = new IndividualUserFunctionClient();
        const promise = client.get(clientId, FunctionName);

        promise
            .onSuccess((data) => {
                this.setState({ hasCompanyPermission: data });
            })
            .onError(() => {
                this.setState({ hasCompanyPermission: false });
            });
    }

    public render(): JSX.Element {
        const { tableData, isLoading } = this.props;

        return (
            <>
                {isLoading ? this.renderPartLoading() : tableData && this.renderTable(tableData)}
                {tableData && tableData.TotalNumberOfResults > 0 && this.renderPagination()}
            </>
        );
    }

    private renderPartLoading() {
        return (
            <PartLoading isLoading={true}>
                <div className="table-skeleton"></div>
            </PartLoading>
        );
    }

    private renderPagination() {
        const { currentPage, pageSize, handlePageChange } = this.props;
        const { TotalNumberOfResults } = this.props.tableData;
        return (
            <div className="row">
                <div className="col-12 col-right">
                    <Pager
                        pager={{
                            CurrentPage: currentPage,
                            ResultsPerPage: pageSize,
                            TotalPages: TotalNumberOfResults / pageSize,
                            TotalRecords: TotalNumberOfResults,
                        }}
                        onChange={(recordsPerPage: number, pageIndex: number) => {
                            handlePageChange(pageIndex);
                        }}
                        recordsPerPageOptions={[10, 15, 20]}
                        isShowPerPageOptions={false}
                    />
                </div>
                {this.renderSubmitButton()}
            </div>
        );
    }

    private renderSubmitButton() {
        const { inprogress } = this.props;
        return (
            inprogress && (
                <div className="col-xs-6 right">
                    <button onClick={() => this.popupMessage()} id="btnSave" className="btn secondary">
                        {ContentTable.save}
                    </button>
                </div>
            )
        );
    }

    private popupMessage() {
        const { itemsToDelete } = this.state;
        if (itemsToDelete.length == 0) {window.alert(ContentTable.noWizardSelected);}
        else if (itemsToDelete.length > 0) {
            const confirm = window.confirm(ContentTable.confirmDelete);
            if (confirm) {this.handleSubmit();}
        }
    }

    private handleSubmit() {
        this.props.handleSubmit(this.state.itemsToDelete);
        this.setState({ itemsToDelete: [] });
    }

    private renderTableRow(data: FirmInstructionHistoryAdapterModel): JSX.Element {
        return (
            <tr key={data.InstructionId}>
                <td>{JsonDateParser.getFormatDate(data.CreatedTime, "dd/MM/yyyy")}</td>
                <td>{CommonHelper.getOptionsTxt(data.FirmProcessType, ProcessTypeOptions)}</td>
                <td>{CommonHelper.getOptionsTxt(data.Status, StatusOptions)}</td>
                <td>{data.FirmName}</td>
                <td>{data.FsaAuthorisationNumber}</td>
                <td>{data.CreatedUser}</td>
                <td>{data.PostCode}</td>
                <td>{JsonDateParser.getFormatDate(data.LastUpdatedTime, "dd/MM/yyyy")}</td>
                <td>{this.renderActionButton(data.InstructionId)}</td>
                {this.renderDeleteBox(data.InstructionId)}
                {/* {this.renderEditNotes()} */}
            </tr>
        );
    }

    private isChecked(id: number) {
        const { itemsToDelete } = this.state;
        if (!itemsToDelete || itemsToDelete.length === 0) {
            return false;
        }
        return itemsToDelete.indexOf(id) >= 0;
    }

    private renderEditNotes() {
        const editNotesUrl = ContentTable.defaultUrl;
        return (
            <td className="text-right">
                <a href={editNotesUrl} className="hyperlink">
                    <span className="text">{ContentTable.editNotes}</span>
                </a>
            </td>
        );
    }

    private renderActionButton(id: number) {
        const { inprogress } = this.props;
        const url = ContentTable.defaultUrl;
        return (
            <a
                href={url}
                className="btn secondary"
                onClick={() => {
                    Navigator.navigateTo(Urls.get().FirmDetail, {
                        scrollAfterNavigating: true,
                        queryParamsObject: { id: id },
                    });
                }}
            >
                <span className="text">
                    {inprogress && this.state.hasCompanyPermission ? ContentTable.resume : ContentTable.view}
                </span>
            </a>
        );
    }

    private renderDeleteBox(id: number) {
        const { inprogress } = this.props;
        return (
            inprogress &&
            this.state.hasCompanyPermission && (
                <td>
                    <input
                        id={id + ""}
                        name={ContentTable.delete}
                        checked={this.isChecked(id)}
                        onChange={(e: any) => {
                            this.handleDeleteChange(id);
                        }}
                        type="checkbox"
                        value="true"
                    />
                </td>
            )
        );
    }

    private handleDeleteChange(id: number) {
        let newItemsToDelete = this.state.itemsToDelete;
        if (this.isChecked(id)) {
            newItemsToDelete = newItemsToDelete.filter((o) => o != id);
        } else {
            newItemsToDelete.push(id);
        }
        this.setState({ itemsToDelete: newItemsToDelete });
    }

    private renderDeleteTHead() {
        const { inprogress } = this.props;
        return inprogress && <th>{ContentTable.delete}</th>;
    }

    private renderTable(tabledata: FirmInstructionHistoryCollectionModel): JSX.Element {
        const { inprogress } = this.props;
        const data = tabledata.PageOfResults;
        if (data.length === 0) {
            return <div id="noDataMsg">{ContentTable.noDataMsg}</div>;
        }

        return (
            <div>
                <table className="data-table">
                    <thead>
                        <tr>
                            <th>{ContentTable.dateStarted}</th>
                            <th>{ContentTable.processType}</th>
                            <th>{ContentTable.status}</th>
                            <th>{ContentTable.firmName}</th>
                            <th>{ContentTable.reference}</th>
                            <th>{ContentTable.createdBy}</th>
                            <th>{ContentTable.postCode}</th>
                            <th>{ContentTable.lastUpdated}</th>
                            <th>{ContentTable.action}</th>
                            {this.renderDeleteTHead()}
                            {/* <th className="text-right">{ContentTable.editNotes}</th> */}
                        </tr>
                    </thead>
                    <tbody className="body-split">
                        <tr className="sub-head">
                            <td colSpan={11}>{tabledata.TotalNumberOfResults + " " + ContentTable.sessions}</td>
                        </tr>
                        {data.map((ele) => {
                            return this.renderTableRow(ele);
                        })}
                    </tbody>
                </table>
            </div>
        );
    }
}
